<template>
    <div>
        <a-tabs defaultActiveKey="1" >

            <a-tab-pane tab="Configuración" key="1" forceRender>

                <a-form id="form-detail-banner" :form="form" class="row" layout="horizontal" @submit="submitSaveProfile">
                    <a-form-item class="col-md-6">
                        <h5>Nombre de Perfil:</h5>
                        <a-input placeholder="Ej. Bebés" v-model="profile.title" />
                    </a-form-item>

                     <a-form-item class="col-md-12">
                        <h5>Seleccione cluster Correspondientes:  {{selectedItemsClusters}} - {{profile.clusters}}</h5>
                            <a-select
                                placeholder="Seleccione Clusters"
                                :defaultValue="profile.idCluster"
                                :value="selectedItemsClusters"
                                @change="selectCluster"
                                showSearch
                                :filterOption="filterOptionClusters"
                                style="width: 100%"
                            >
                                <a-select-option v-for="item in clusters" :key="item.id" :value="item.id">
                                {{item.name}}
                                </a-select-option>
                            </a-select>
                    </a-form-item>
<!--
                    <a-form-item class="col-md-12">
                        <h5>Proveedores:</h5>
                            <a-select
                                mode="multiple"
                                placeholder="Seleccione proovedores"
                                :value="selectedItems"
                                @change="handleChange"
                                style="width: 100%">

                                <a-select-option v-for="item in filteredOptions" :key="item" :value="item">
                                {{item}}
                                </a-select-option>

                            </a-select>
                    </a-form-item>

                    <a-form-item class="col-md-6">
                        <h5>Marcas:</h5>
                            <a-select
                                mode="multiple"
                                placeholder="Seleccione marcas"
                                :value="selectedItems"
                                @change="handleChange"
                                style="width: 100%"
                            >
                                <a-select-option v-for="item in filteredOptions" :key="item" :value="item">
                                {{item}}
                                </a-select-option>
                            </a-select>
                    </a-form-item>

                    <a-form-item class="col-md-6">
                        <h5>Departamento:</h5>
                            <a-select
                                mode="multiple"
                                placeholder="Seleccione por departamentos"
                                :value="selectedItems"
                                @change="handleChange"
                                style="width: 100%"
                            >
                                <a-select-option v-for="item in filteredOptions" :key="item" :value="item">
                                {{item}}
                                </a-select-option>
                            </a-select>
                    </a-form-item>

                    <a-form-item class="col-md-6">
                        <h5>Clase:</h5>
                            <a-select
                                mode="multiple"
                                placeholder="Seleccione clase"
                                :value="selectedItems"
                                @change="handleChange"
                                style="width: 100%"
                            >
                                <a-select-option v-for="item in filteredOptions" :key="item" :value="item">
                                {{item}}
                                </a-select-option>
                            </a-select>
                    </a-form-item>

                    <a-form-item class="col-md-6">
                        <h5>Subclase:</h5>
                            <a-select
                                mode="multiple"
                                placeholder="Seleccione subclase"
                                :value="selectedItems"
                                @change="handleChange"
                                style="width: 100%"
                            >
                                <a-select-option v-for="item in filteredOptions" :key="item" :value="item">
                                {{item}}
                                </a-select-option>
                            </a-select>
                    </a-form-item>

                    <a-form-item class="col-md-12">
                        <h5>Configuración por item:</h5>
                            <a-select
                                mode="multiple"
                                placeholder="Seleccione item"
                                :value="selectedItems"
                                @change="handleChange"
                                style="width: 100%"
                            >
                                <a-select-option v-for="item in filteredOptions" :key="item" :value="item">
                                {{item}}
                                </a-select-option>
                            </a-select>
                    </a-form-item> -->
                </a-form>

            </a-tab-pane>
<!-- 
            <a-tab-pane tab="Banners" key="2" >

                {{profileBanners}}
                <draggable v-model="profileBanners"  :componentData="componentData">
                    <transition-group type="transition" name="flip-list" > 
                        <li class="list-group-item d-flex justify-content-between align-items-center" v-for="element in banners" :key="element.idBanner">
                            <i class="fa fa-align-justify handle"></i>
                            <img class="img-fluid rounded" :src="element.urlBanner" alt="">
                        </li>
                    </transition-group> 
                </draggable>

                <div  v-if="banners.length == 0">
                    <p class="text-center">0 Banners definidos en este perfil</p>
                </div>

            </a-tab-pane>

            <a-button slot="tabBarExtraContent" icon="ordered-list" @click="updateOrderBanner(profile.idCluster)" v-if="profile.idCluster">Actualizar Orden</a-button> -->

            <!-- <a-button slot="tabBarExtraContent" icon="save" @click="updateDataAlgolia(false)" v-else>Crear Nuevo Perfil</a-button> -->

        </a-tabs>

          <div :style="{
                position: 'absolute',
                left: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
              }" >

        <a-button v-if="profile.idCluster" :style="{marginRight: '8px', float:'left'}"  @click="onDeleteProfile(profile.idCluster)" :loading="loadingDelete"> Borrar </a-button>

        <a-button :style="{marginRight: '8px'}"  @click="$emit('closeDetail', false)" > Cerrar </a-button>

        <a-button v-if="!profile.idCluster" :style="{marginRight: '8px'}" type="primary" @click="submitSaveProfile()" :loading="loadingSave">Guardar Perfil</a-button>
        <a-button v-else :style="{marginRight: '8px'}" type="primary" :loading="loadingSave" @click="updateProfile()">Actualizar Perfil</a-button>

      </div>

<!--
            <a-form-item class="col-md-12" >
                <a-button type="primary"  >Guardar Perfil</a-button>
            </a-form-item> -->

    </div>
</template>

<script>
import draggable from 'vuedraggable'

import { RepositoryFactory } from '@/repository/RepositoryFactory'

const BannersRepository = RepositoryFactory.get('banners')
const ProfilesRepository = RepositoryFactory.get('profiles')

const OPTIONS = []

export default {
  name: 'ItemDetails',
  components: {
    draggable,
  },
  data () {
    return {
      loading: false,
      form: this.$form.createForm(this, { name: 'profileForm' }),
      imageUrl: '',
      banners: [],
      profileBanners: [],
      componentData: {
        props: {
          type: 'transition',
          name: 'flip-list',
        },
      },
      loadingSave: false,
      loadingDelete: false,
      newProfile: {},
      selectedItems: [],
      selectedItemsClusters: this.profile.idCluster,
    }
  },
  props: ['profile', 'clusters', 'isUpdated'],
  computed: {
    // filteredOptions() {
    //   return OPTIONS.filter(o => !this.selectedItems.includes(o))
    // },
  },
  watch: {
    profile: function () {
      this.selectedItemsClusters = this.profile.idCluster || null
      // this.profile.sliders = []
      console.log(' this.profile.clusters:: ', this.profile)
      this.getBannerByCluster()
    },
  },
  methods: {
    handleChange(selectedItems) {
      this.selectedItems = selectedItems
    },
    selectCluster(selectedItems, x) {
      console.log('selectCluster', selectedItems, x)
      this.selectedItemsClusters = selectedItems
    },
    filterOptionClusters(input, option) {
      return
      this.clusters.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    async submitSaveProfile() {
      let payload = {
        'idCluster': this.selectedItemsClusters,
        'namePerfil': this.profile.namePerfil,
        'clusterName': this.profile.namePerfil,
      }

      ProfilesRepository.insertProfiles(payload).then((res) => {
        console.log(payload, res)
        this.$emit('updateProfiles', true) 
        this.$emit('closeDetail', true) 
        
      })
    },

    async onDeleteProfile(idCluster) {
      console.log('idCluster', idCluster)

      const data = await ProfilesRepository.deleteCluster(idCluster)
      this.$emit('closeDetail', true)
        this.$emit('updateProfiles', true) 

      console.log('onDeleteProfile', data)
    },

    async updateProfile() {
      let payload = {
        'idCluster': this.selectedItemsClusters,
        'namePerfil': this.profile.namePerfil,
        'clusterName': this.profile.namePerfil,
      }
      const data = await ProfilesRepository.updateProfile(payload);
      this.$emit('closeDetail', true); 
        this.$emit('updateProfiles')
    },

    getBannerByCluster() {
      console.log('profile.id', this.profile)
      this.banners = []
      try {
        const data = BannersRepository.getBannersByCluster(this.profile.idCluster).then(({ data }) => {
          console.log('BannersRepository', data.data)
          this.banners = data.data
        })
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },
    // async updateDataAlgolia(toUpdated) {
    //   this.profile.clusters = this.selectedItemsClusters

    //   if (!this.profile.hasOwnProperty('sliders')) {
    //     this.profile.sliders = []
    //   }

    //   // console.log(this.profile.clusters)

    //   try {
    //     const { objectIDs } = toUpdated ? await AlgoliaRepository.profiles.saveObject(this.profile)
    //       : await AlgoliaRepository.profiles.addObjects([this.profile])

    //     console.log(objectIDs)
    //   } catch (error) {
    //     this.$notification['warning']({
    //       message: error.code,
    //       description: error.message,
    //     })
    //   }
    // },

  },
}
</script>

<style lang="css">
    .ant-drawer-title{
        color:#001e62;
        font-weight: bold;
        font-size: 15pt;
        font-family: 'Open Sans Condensed', sans-serif;
        text-transform: uppercase
    }
    h5{
        color:#001e62;
        font-weight: bold;
        font-size: 12pt;
        font-family: 'Open Sans Condensed', sans-serif;
    }
    p.ant-upload-drag-icon {
        text-align: center;
        padding: 0px 10px;
        display: block;
        margin: 0px!important;
    }

    p.ant-upload-text {

        font-size: 14px!important;

    }

    .ant-upload-drag-container {padding: 0px; line-height: 13px;}

    span.ant-upload.ant-upload-btn {
        padding: 0px!important;
        /* border: 1px #ddd dotted; */
    }

    .ant-upload.ant-upload-drag {
        border: 2px dashed #e4e9f0;
        background-color: transparent;
        height: 70px;
    }

    .ant-upload.ant-upload-drag p.ant-upload-text{
            margin: 10px 0 1px;
    }

    .flip-list-move {
    transition: transform 0.5s;
    }
    .no-move {
    transition: transform 0s;
    }
    .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    }
    .list-group {
    min-height: 20px;
    }
    .list-group-item {
    cursor: move;
    }
    .list-group-item i {
    cursor: pointer;
    }
</style>